import { useState } from "react";
import { toast } from "react-toastify";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { Button } from "components/ui";

const ExportButtons = ({ path, params = {}, filename }) => {
  const axiosPrivate = useAxiosPrivate();
  const [busy, setBusy] = useState(null);

  const download = async (format) => {
    setBusy(format);

    try {
      const response = await axiosPrivate.get(
        `/api/accountant/export/${path}`,
        {
          params: {
            ...params,
            format,
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}.${format}`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      toast.error(`Failed to export ${format.toUpperCase()} report`);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div
      style={{
        display: "inline-flex",
        gap: 8,
        alignItems: "center",
      }}
    >
      <Button
        variant="secondary"
        size="sm"
        disabled={!!busy}
        onClick={() => download("xlsx")}
      >
        {busy === "xlsx" ? "Exporting…" : "Excel"}
      </Button>

      <Button
        variant="secondary"
        size="sm"
        disabled={!!busy}
        onClick={() => download("pdf")}
      >
        {busy === "pdf" ? "Exporting…" : "PDF"}
      </Button>
    </div>
  );
};

export default ExportButtons;